angular.module('lf.common')

.directive('wishlistButton', function (i18n, gtmService) {
  var isMobileUI = lf.data.xhr.client.mobileUI;
  
  return {

    restrict: 'EA',

    scope: {
      wishlistItem: '&?'
    },
    
    controller: function ($scope, $injector, wishlistService, notificationService, gtmService) {
      $scope.add = function () {
        if ($scope.requesting) return;
        
        $scope.requesting = 'add';
        $scope.$emit('wishlist:requesting', true);

        wishlistService.add({product: $scope.product})
          .success(function (data) {
            if (data.data && (data.data.error || !data.data.success)) {
              return notifyError();
            }

            if ($scope.product.gaLocation && $scope.product.gaLocation.toLowerCase() === 'cart') {
              gtmService.pushAddToWishlistFromCart($scope.product);
            } else {
              gtmService.pushAddToWishlist($scope.product);
            }

            $scope.added = true;
            if (isMobileUI) {
              notifySuccess(i18n.notify.addedToWishlist, 'add');
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            $scope.$emit('wishlist:requesting', false);
            delete $scope.requesting;
          });
      };

      $scope.remove = function () {
        if ($scope.requesting) return;
        
        $scope.requesting = 'remove';
        $scope.$emit('wishlist:requesting', true);

        wishlistService.remove({product: $scope.product})
          .success(function (data) {
            if (data.data && (data.data.error || !data.data.success)) {
              return notifyError();
            }

            gtmService.pushRemoveFromWishlist($scope.product);

            $scope.removed = true;
            if (isMobileUI) {
              notifySuccess(i18n.notify.removedFromWishlist, 'remove');
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            $scope.$emit('wishlist:requesting', false);
            delete $scope.requesting;
          });
      };

      $scope.moveToCart = function () {
        if ($scope.requesting) return;
        
        $scope.requesting = 'addToCart';
        $scope.$emit('wishlist:requesting', true);

        wishlistService.addToCart({product: $scope.product})
          .success(function (data) {
            if (data.data && (data.data.error || !data.data.success)) {
              return notifyError();
            }

            gtmService.pushAddToCartFromWishlist($scope.product);

            $scope.addedToCart = true;
            if (isMobileUI) {
              notifySuccess(i18n.notify.addedToCartNotification, 'addToCart');
            }
          })
          .error(function (data) {
            notifyError();
          })
          .finally(function () {
            $scope.$emit('wishlist:requesting', false);
            delete $scope.requesting;
          });
      };
      
      function notifySuccess (msg, action) {
        var actionClass = '';

        switch(action) {
          case 'add':
            actionClass = 'fa-heart';
            break;
          case 'remove':
            actionClass = 'fa-times';
            break;
          case 'addToCart':
            actionClass = 'fa-shopping-cart';
            break;
        }

        notificationService.show({
          text: '<i class="fa ' + actionClass + '"></i>' + $scope.product.title + ' <b>' + msg + '</b>'
        });
      };
      
      function notifyError () {
        if (isMobileUI) {
          notificationService.show({
            text: '<b class="b-red">' + i18n.notify.generalErrorTitle + '</b><br>' + i18n.notify.generalErrorText,
            error: true
          });
        } else {
          var popupsService = $injector.get('popupsService');
          var errorMessage = '<b>' + i18n.notify.generalErrorTitle + '</b><br />' +
                             i18n.notify.generalErrorText;
          popupsService.showError(errorMessage);
        }
      };
    },
    
    link: function (scope, el, attrs) {
      var product = scope.wishlistItem() || {
        id: attrs.productId,
        skuId: attrs.productSkuId,
        cartItemId: attrs.cartItemId,
        title: (attrs.productTitle || '').replace(/(^\s+|\s+$)/g, '')
      }

      gtmService.getClosestLocation(el, product);
      product['resPosition'] = attrs.gaResultposition;

      var button = {
        text: el.html()
      }
      
      scope.product = product;
      
      var clickEvent = el.parents('[scrollable]').length ? 'tap' : 'click';
      
      el.on(clickEvent, function () {
        scope[attrs.wishlistButton]();
      });
      
      if (isMobileUI) {
        scope.$watch('requesting', function (requesting) {
          var classify = (requesting ? 'add' : 'remove') + 'Class';
          el[classify]('btn-wishlist-requesting');
//          el.html(requesting ? i18n.notify.updating : button.text);
          el.attr('disabled', !!requesting);
        });
        
        scope.$watch('added', function (added) {
          var classify = (added ? 'add' : 'remove') + 'Class';
          el.html(added ? i18n.notify.addToWishlist : button.text);
        });

        scope.$watch('addedToCart', function (addedToCart) {
          el.html(addedToCart ? i18n.notify.addedToCart : button.text);
          el.attr('disabled', addedToCart);
        });

        scope.$on('$destroy', function () {
          el.off(clickEvent);
        });

        scope.$watch('requesting', function (requesting) {
          switch (requesting) {
            case 'add':
              el.html(i18n.notify.updating);
              break;
            case 'remove':
              el.html(i18n.notify.removingFromCart + '...');
              break;
            case 'addToCart':
              el.html(i18n.notify.addingToCart + '...');
              break;
            default:
              el.html(button.text);
              break;
          }
        });
      }
      
    }
  }
});
